module.exports = __webpack_public_path__ + "img/phone.8675ba8b.png";